import {useState, useEffect} from "react";
import Menu from "@mui/material/Menu";

export default function ContextMenu({
  triggerContent,
  menuItems,
  isClosed,
  ...props
}) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleContextMenu = event => {
    event.preventDefault();
    let target = event.currentTarget;
    const rowElement = target.closest('[class*="rowListSong"], [class*="musicShelf"]');
    if (rowElement) {
      target = rowElement;
    }
    const rect = target.getBoundingClientRect();
    const anchorEl = document.createElement("div");
    anchorEl.style.position = "fixed";
    anchorEl.style.left = `${rect.left - 69}px`;
    anchorEl.style.top = `${rect.bottom}px`;
    anchorEl.id = "context-menu-anchor";
    document.body.appendChild(anchorEl);
    setAnchorEl(anchorEl);
  };

  const handleClose = () => {
    const existingAnchor = document.getElementById("context-menu-anchor");
    if (existingAnchor) {
      existingAnchor.remove();
    }
    setAnchorEl(null);
  };

  useEffect(() => {
    if (isClosed) {
      handleClose();
    }
  }, [isClosed]);

  const glassPaperProps = {
    style: {
      height: "max-content",
      width: "28rem",
      background: "rgba(15, 15, 15, 0.75)",
      backdropFilter: "blur(40px) saturate(200%)",
      WebkitBackdropFilter: "blur(40px) saturate(200%)",
      borderRadius: "20px",
      border: "1px solid rgba(255, 255, 255, 0.1)",
      boxShadow: "0 24px 80px rgba(0, 0, 0, 0.8), 0 8px 32px rgba(0, 0, 0, 0.5)",
      padding: "0.8rem",
      overflow: "visible",
    },
  };

  return (
    <div onContextMenu={handleContextMenu} style={{cursor: "context-menu"}}>
      {triggerContent}
      <Menu
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorEl={anchorEl}
        anchorOrigin={{vertical: "top", horizontal: "left"}}
        transformOrigin={{vertical: "top", horizontal: "left"}}
        PaperProps={glassPaperProps}
        disableRestoreFocus={true}
        {...props}
        className={`dark-mode ${props?.className || ""}`}>
        {menuItems}
      </Menu>
    </div>
  );
}
